module.exports = __webpack_public_path__ + "static/media/heart42.9bceb314.svg";